<template>
  <div>
    <Head :title="vertical.name"/>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/verticals">Verticals</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>{{ form.name }}</b-breadcrumb-item>
    </b-breadcrumb>
    <trashed-message v-if="vertical.deleted_at" class="mb-6" @restore="restore"> This vertical has been deleted.</trashed-message>
    <card-component>
      <form @submit.prevent="update">
        <text-input v-model="form.name" :error="form.errors.name" class="mb-2" label="Name"/>

        <div class="is-flex is-justify-content-flex-end px-8 py-4">
          <b-button type="is-info" native-type="submit">
            Update Vertical
          </b-button>
        </div>
      </form>

    </card-component>
    <card-component :title="`Markets for: ${vertical.name}`">
      <b-table striped bordered :data="vertical.markets" >
        <b-table-column label="Market" v-slot="{row}" field="city" sortable>
          <Link class="" :href="`/sector-targets/${row.sector_target.id}`">
            {{ row.city }}
          </Link>
        </b-table-column>
      </b-table>
    </card-component>

    <card-collapsible title="Site Content" :open="!vertical.site_content">
      <div v-if="vertical.site_content">
      <div v-for="(section, index) in siteContentJson.sections" :key="section+index">
        {{ section.title }}
        <div v-html="section.body" />
        <hr />
      </div>
      </div>
      <div v-if="vertical.site_content">
        <b-button tag="Link" type="is-info":href="`/site-content/edit/${vertical.site_content.id}`" as="button">
          Edit Site Content
        </b-button>
      </div>
      <div v-else>
        <b-button tag="Link" type="is-info":href="`/site-content/vertical/create/${vertical.id}`" as="button">
          Add Site Content
        </b-button>
      </div>
    </card-collapsible>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import CardComponent from "@/Shared/CardComponent";
import CardCollapsible from "@/Shared/CardCollapsible";

export default {
  components: {
    CardComponent,
    CardCollapsible,
    TextInput,
    TrashedMessage,
  },
  props: {
    vertical: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: _.clone(this.vertical.name),
      }),
      siteContentJson: this.parseSiteContent()
    }
  },
  methods: {
    update() {
      this.form.put(`/verticals/${this.vertical.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this vertical?')) {
        this.$inertia.delete(`/verticals/${this.vertical.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this vertical?')) {
        this.$inertia.put(`/verticals/${this.vertical.id}/restore`)
      }
    },
    parseSiteContent(){
      if(!this.vertical.site_content){
        return null
      }
      return JSON.parse(this.vertical.site_content.json)
    }
  },
}
</script>
